<template>
    <vs-select v-model="selected"
               :label="$t('editor.size.length')"
               width="100%"
               :value="value"
               @input="inputChanged"
               :id="'dropdown' + _uid"
               :name="'dropdown' + _uid"
               v-validate="'required'"
               autocomplete
               :placeholder="$t('choose')">
        <vs-select-item :key="index"
                        :value="item.id"
                        :text="item.text"
                        v-for="(item,index) in items"/>
    </vs-select>
</template>

<script>
    import { ComponentSize } from '../../models/enums';

    export default {
        props: {
            value: [Number, String]
        },
        data() {
            return {
                selected: 'col-6',
                items: [
                    {
                        id: ComponentSize.Small,
                        text: this.$t('editor.size.small')
                    },
                    {
                        id: ComponentSize.Medium,
                        text: this.$t('editor.size.medium')
                    },
                    {
                        id: ComponentSize.Large,
                        text: this.$t('editor.size.large')
                    }
                ]
            }
        },
        methods: {
            inputChanged(event) {
                this.$emit('input', this.selected);
            }
        },
        watch: {
            value: {
                immediate: true,
                handler (newVal, oldVal) {
                    this.selected = newVal;
                    this.active = false;
                }
            }
        }
    }
</script>
